<template>
<div>
  <el-dialog title="请速修改类目，避免商品下架"  :visible.sync="visible1" width="520px" @close="closeOne">
      <img src="../../assets/images/isv_1.png" class="img">
      <div class="tip">你发布的部分商品存在违规发布定邀/定准类目商品的风险，请于12月11日前按推荐申请类目权限并修改，逾期未改商品将下架</div>
    <template #footer>
      <el-button @click="closeOne">取消</el-button>
      <el-button type="primary"  @click="handleView">立即查看</el-button>
    </template>
  </el-dialog>
  <el-dialog title="详情"  :visible.sync="visible2" width="650px" @close="closeAll">
    <div class="sub_title">已开启「AI尺码表自动优化」增加尺码曝光，预估转化+2%</div>
      <img src="../../assets/images/isv_2.png" class="img">
      <div class="tip2 f12 txt_c">如平台将对店铺内商品的尺码表信息进行补充、更正等优化，详见 功能说明</div>
      <div class="tip2 f12 txt_c">如需关闭尺码表自动优化，请点击下方前往抖店商品管理页按钮进入自动化记录页，页面右上角即可关闭</div>
    <template #footer>
      <el-button @click="closeAll">取消</el-button>
      <el-button type="primary"  @click="handleGo">前往抖店商品管理页</el-button>
    </template>
  </el-dialog>
</div>
</template>
<script>
export default {
  data(){
    return {
      visible1:false,
      visible2: false
    }
  },
  mounted(){
 /*   let now =new Date().getTime()
    if(!localStorage.getItem('isv_show') ||localStorage.getItem('isv_show') && now - localStorage.getItem('isv_show') > 1000*60*60*2){
      this.visible1 = true
    }*/
  },
  methods:{
    show(){
      this.visible1 = true
    },
    handleView(){
      this.visible2=true
    },
    handleGo(){
      this.closeAll()
      this.$router.push('/uc_goods?menuId=120')
    },
    closeOne(){
      this.visible1=false
      localStorage.setItem('isv_show',new Date().getTime())
    },
    closeAll(){
      this.visible1=false
      this.visible2=false
      localStorage.setItem('isv_show',new Date().getTime())
    },
  }
}
</script>


<style scoped>
.txt_c{
  text-align: center;
}
.f12{
  font-size: 13px;
}
.img{
  width: 100%;
  height: auto;
}
:deep(.el-dialog__body) {
  padding: 0px 20px 20px;
}
.tip{
  margin-top: 10px;
  color: #666666;
  font-weight: 500;
  line-height: 24px;
}
.sub_title{
  font-weight: bold;
  text-align: center;
  font-size: 16px;
}
</style>
